var Shopify = Shopify || {};
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class RemoveBundleItem extends HTMLElement {
  constructor() {
    super();
    this.removeBtn = this.querySelector("button");
    this.removeBtn.addEventListener("click", this.removeItem.bind(this));
  }
  removeItem(event) {
    event.preventDefault();
    const bundleItem = document.querySelector(
      `bundle-item[data-product-id="${this.dataset.productId}"]`
    );
    if (bundleItem) {
      bundleItem.removeItem();
      publish(PUB_SUB_EVENTS.bundleItemAdded, {});
    }
  }
}
customElements.define("remove-bundle-item", RemoveBundleItem);

class BundleItem extends HTMLElement {
  constructor() {
    super();
    this.quantity = 0;
    this.addBtn = this.querySelector("[data-add-item]");
    this.addBtn.addEventListener("click", this.addItem.bind(this));
    this.html = this.querySelector(".html");
    this.checkProductAvailability();
  }
  addItem(event) {
    event.preventDefault();

    const bundleSummary = document.querySelector("bundle-summary");
    if (bundleSummary.totalItems >= bundleSummary.bundleLimit) {
      return; // Do not add more items if limit is reached
    }
    
    this.quantity++;
    this.setAttribute("data-active", "true");
    this.checkProductAvailability();
    publish(PUB_SUB_EVENTS.bundleItemAdded, {});
  }

  removeItem() {
    this.quantity--;
    this.checkProductAvailability();
    if (this.quantity === 0) {
      this.removeAttribute("data-active");
    }
  }

  getHtml() {
    return this.html.innerHTML;
  }

  checkProductAvailability() {
    if (this.hasAttribute("data-inventory")) {
      if (this.quantity >= parseInt(this.dataset.inventory)) {
        this.addBtn.setAttribute("disabled", "disabled");
      } else {
        this.addBtn.removeAttribute("disabled");
      }
    }
    if (this.dataset.available != "true") {
      this.addBtn.setAttribute("disabled", "disabled");
    }
  }
}

customElements.define("bundle-item", BundleItem);

class BundleSummary extends HTMLElement {
  constructor() {
    super();
    this.totalItems = 0;
    this.totalPrice = 0;
    this.bundleLimit = 3;
    this.selectedContainer = this.querySelector("[data-bundle-selected-items]");
    this.addToCartBtn = this.querySelector("[data-pi-addto-cart]");
    this.cart = document.querySelector("cart-drawer");
    this.hideBundle = this.querySelector("[data-hide-bundle-mob]");
    this.bundleBtns = this.querySelectorAll(".alh-select-bundle-btn");

    if (this.hideBundle) {
      this.hideBundle.addEventListener("click", () => {
        this.selectedContainer.toggleAttribute("hidden");
      });
    }

    this.bundleBtns.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        this.updateBundleLimit(event.target);
      });
    });

    this.addToCartBtn.addEventListener("click", this.addToCart.bind(this));
  }

  updateBundleLimit(selectedBtn) {
    this.bundleBtns.forEach((btn) => btn.classList.remove("selected"));
    selectedBtn.classList.add("selected");
    this.bundleLimit = parseInt(selectedBtn.textContent.split("-")[0]);
    this.renderBundleInfo();
  }

  
  unSubscribebundleItemAdded = undefined;
  connectedCallback() {
    this.unSubscribebundleItemAdded = subscribe(
      PUB_SUB_EVENTS.bundleItemAdded,
      this.itemAdded.bind(this)
    );
  }
  disconnectedCallback() {
    this.unSubscribebundleItemAdded();
  }
  itemAdded() {
    this.totalItems = 0;
    this.totalPrice = 0;
    var html = "";
    document.querySelectorAll("bundle-item[data-active]").forEach((item) => {
      this.totalItems += item.quantity;
      this.totalPrice += parseFloat(item.dataset.price) * item.quantity;
      for (let i = 1; i <= item.quantity; i++) {
        html += item.getHtml();
      }
    });
    this.selectedContainer.innerHTML = html;

    if (this.totalItems > 0) {
      this.removeAttribute("data-empty");
    } else {
      this.setAttribute("data-empty", "");
    }

    this.renderBundleInfo();
  }
  renderBundleInfo() {
    // Calculate progress as a percentage
  const progress = Math.min((this.totalItems / this.bundleLimit) * 100, 100); // Capped at 100%

  // Set button background as progress color
  this.addToCartBtn.style.background = `linear-gradient(to right, #000000 ${progress}%, #191919 ${progress}%)`;

    
    this.addToCartBtn.innerHTML = `Add ${
      this.totalItems
    } to cart - ${Shopify.formatMoney(this.totalPrice, Shopify.money_format)}`;
    if (this.totalItems >= this.bundleLimit) {
      this.addToCartBtn.removeAttribute("disabled");
    } else {
      this.addToCartBtn.setAttribute("disabled", "disabled");
    }
  
    const messageBottomBar = document.querySelector(".bundle-details-message");
    const remainingItems = this.bundleLimit - this.totalItems;
    var btnText = `Pick ${remainingItems} More to complete your 3-pack for $8 shipping.`;
    var atcBtnText = `${this.totalItems}/${this.bundleLimit} bottles added`;
    if (this.totalItems === 0) {
      atcBtnText = `Please add bottle`;
      messageBottomBar.style.display = 'none';
    }
    if (this.bundleLimit === 3) {
      btnText = `Pick ${remainingItems} More to complete your 3-pack for $8 shipping.`;
    } else if (this.bundleLimit === 6) {
      btnText = `Pick ${remainingItems} More to unlock $5 off and FREE Shipping.`;
    } else {
      btnText = `Pick ${remainingItems} More  to get 2 FREE bottles and FREE Priority Shipping.`;
    }
    
    if (this.totalItems >= this.bundleLimit) {
      atcBtnText = `Add to Cart - ${Shopify.formatMoney(
        this.totalPrice,
        Shopify.money_format
      )}`;
      messageBottomBar.style.display = 'none';
    } else {
      messageBottomBar.style.display = 'block';
    }
    this.addToCartBtn.innerHTML = atcBtnText;
    messageBottomBar.innerHTML = btnText;
  }

  addToCart(event) {
    event.preventDefault();
    if (this.totalItems === 0) {
      return;
    }
    this.addToCartBtn.classList.add("loading");
    this.addToCartBtn.setAttribute("disabled", "disabled");

    var body = {
      items: Array.from(
        document.querySelectorAll("bundle-item[data-active]")
      ).map((item) => {
        return {
          id: parseInt(item.dataset.variantId),
          quantity: item.quantity,
        };
      }),
    };
    if (this.cart) {
      body.sections = this.cart.getSectionsToRender().map((t) => t.id);
      body.sections_url = window.location.pathname;
      //   this.cart.setActiveElement(document.activeElement);
    }

    body = JSON.stringify(body);
    fetch(routes.cart_add_url, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "bundle-summary",
            errors: response.description,
            message: response.message,
          });
          return;
        }
        if (this.cart) {
          this.cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .finally(() => {
        this.addToCartBtn.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        this.addToCartBtn.removeAttribute("disabled");
      });
  }
}

customElements.define("bundle-summary", BundleSummary);
